module.exports = __webpack_public_path__ + "img/11087933_L.ca6b3993.png";